import { render, staticRenderFns } from "./DiscountCustomerActivity.vue?vue&type=template&id=1b98632a"
import script from "./DiscountCustomerActivity.vue?vue&type=script&lang=js"
export * from "./DiscountCustomerActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports